import Vue from 'vue';
import VueQrcodeReader from 'vue-qrcode-reader';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import alert from './plugins/alert';
import filters from './filters/filters';

import './registerServiceWorker';
import './registerSentry';
require('dotenv').config();

Vue.config.productionTip = false;

Vue.use(alert, { store });
Vue.use(VueQrcodeReader);

Vue.filter('monetary', filters.monetary);
Vue.filter('multilingual', filters.multilingual);

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');

store.$app = app;
